import { render, staticRenderFns } from "./SystemWallets.vue?vue&type=template&id=763a9e7e"
import script from "./SystemWallets.vue?vue&type=script&lang=js"
export * from "./SystemWallets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports